import script from "./SidebarScale.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarScale.vue?vue&type=script&setup=true&lang=js"

import "./SidebarScale.vue?vue&type=style&index=0&id=389e1183&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-389e1183"]])

export default __exports__